import type { MessageAttachment } from '@/types/conversations'
import { resolveAttachmentMediaUrl } from '@/lib/resolveAttachmentMediaUrl'

interface StickerAttachmentProps {
  attachment: MessageAttachment
}

export function StickerAttachment({ attachment }: StickerAttachmentProps) {
  const src = resolveAttachmentMediaUrl(attachment.file_url)
  if (!src) {
    return <span className="text-2xl">🎭</span>
  }
  return <img src={src} alt="Sticker" className="h-24 w-24 rounded-md object-contain" />
}
